export default __webpack_public_path__ + "static/media/single-left-border-none.f7423722.svg";